<template>
  <div>
    <Header></Header>
    <div style="padding: 5px;">
      <router-view></router-view>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

export default {
  components: {
    Header,
    Footer
  }
};
</script>

<style>
div.container {
  padding-top: 5px;
}
header a,
footer a {
  color: orange;
}

header a:hover,
footer a:hover {
  color: white;
}
</style>
